module.exports = __webpack_public_path__ + "static/media/code-branch.2f32860d.svg";